import { z } from "zod";
import {
  DTOCreateDocumentationGroupInput,
  DTOCreateDocumentationTabInput,
  DTODeleteDocumentationGroupInput,
  DTODeleteDocumentationTabGroupInput,
  DTODuplicateDocumentationGroupInput,
  DTOMoveDocumentationGroupInput,
  DTOUpdateDocumentationGroupInput,
} from "./group-v2";

//
// Read
//

const SuccessPayload = z.object({
  success: z.literal(true),
});

export const DTODocumentationGroupCreateActionOutputV2 = z.object({
  type: z.literal("DocumentationGroupCreate"),
  output: SuccessPayload,
});

export const DTODocumentationTabCreateActionOutputV2 = z.object({
  type: z.literal("DocumentationTabCreate"),
  output: SuccessPayload,
});

export const DTODocumentationGroupUpdateActionOutputV2 = z.object({
  type: z.literal("DocumentationGroupUpdate"),
  output: SuccessPayload,
});

export const DTODocumentationGroupMoveActionOutputV2 = z.object({
  type: z.literal("DocumentationGroupMove"),
  output: SuccessPayload,
});

export const DTODocumentationGroupDuplicateActionOutputV2 = z.object({
  type: z.literal("DocumentationGroupDuplicate"),
  output: SuccessPayload,
});

export const DTODocumentationGroupDeleteActionOutputV2 = z.object({
  type: z.literal("DocumentationGroupDelete"),
  output: SuccessPayload,
});

export const DTODocumentationTabGroupDeleteActionOutputV2 = z.object({
  type: z.literal("DocumentationTabGroupDelete"),
  output: SuccessPayload,
});

export type DTODocumentationGroupCreateActionOutputV2 = z.infer<typeof DTODocumentationGroupCreateActionOutputV2>;
export type DTODocumentationTabCreateActionOutputV2 = z.infer<typeof DTODocumentationTabCreateActionOutputV2>;
export type DTODocumentationGroupUpdateActionOutputV2 = z.infer<typeof DTODocumentationGroupUpdateActionOutputV2>;
export type DTODocumentationGroupMoveActionOutputV2 = z.infer<typeof DTODocumentationGroupMoveActionOutputV2>;
export type DTODocumentationGroupDuplicateActionOutputV2 = z.infer<typeof DTODocumentationGroupDuplicateActionOutputV2>;
export type DTODocumentationGroupDeleteActionOutputV2 = z.infer<typeof DTODocumentationGroupDeleteActionOutputV2>;
export type DTODocumentationTabGroupDeleteActionOutputV2 = z.infer<typeof DTODocumentationTabGroupDeleteActionOutputV2>;

//
// Write
//

export const DTODocumentationGroupCreateActionInputV2 = z.object({
  type: z.literal("DocumentationGroupCreate"),
  input: DTOCreateDocumentationGroupInput,
});

export const DTODocumentationTabCreateActionInputV2 = z.object({
  type: z.literal("DocumentationTabCreate"),
  input: DTOCreateDocumentationTabInput,
});

export const DTODocumentationGroupUpdateActionInputV2 = z.object({
  type: z.literal("DocumentationGroupUpdate"),
  input: DTOUpdateDocumentationGroupInput,
});

export const DTODocumentationGroupMoveActionInputV2 = z.object({
  type: z.literal("DocumentationGroupMove"),
  input: DTOMoveDocumentationGroupInput,
});

export const DTODocumentationGroupDuplicateActionInputV2 = z.object({
  type: z.literal("DocumentationGroupDuplicate"),
  input: DTODuplicateDocumentationGroupInput,
});

export const DTODocumentationGroupDeleteActionInputV2 = z.object({
  type: z.literal("DocumentationGroupDelete"),
  input: DTODeleteDocumentationGroupInput,
});

export const DTODocumentationTabGroupDeleteActionInputV2 = z.object({
  type: z.literal("DocumentationTabGroupDelete"),
  input: DTODeleteDocumentationTabGroupInput,
});

export type DTODocumentationGroupCreateActionInputV2 = z.infer<typeof DTODocumentationGroupCreateActionInputV2>;
export type DTODocumentationTabGroupCreateActionInputV2 = z.infer<typeof DTODocumentationTabCreateActionInputV2>;
export type DTODocumentationGroupUpdateActionInputV2 = z.infer<typeof DTODocumentationGroupUpdateActionInputV2>;
export type DTODocumentationGroupMoveActionInputV2 = z.infer<typeof DTODocumentationGroupMoveActionInputV2>;
export type DTODocumentationGroupDuplicateActionInputV2 = z.infer<typeof DTODocumentationGroupDuplicateActionInputV2>;
export type DTODocumentationGroupDeleteActionInputV2 = z.infer<typeof DTODocumentationGroupDeleteActionInputV2>;
export type DTODocumentationTabGroupDeleteActionInputV2 = z.infer<typeof DTODocumentationTabGroupDeleteActionInputV2>;
